import { useGateValue } from '@statsig/react-bindings';
import { useSelector } from 'react-redux';
import { RootState } from 'src/app/store';
import { MULTI_COMPANY_ACCESS } from 'src/types/FeataureFlags';

const useHasMultiCompanyAccess = (): boolean => {
  const companyCount = useSelector(
    (state: RootState) => state.auth.companyContext.companyCount
  );
  const hasMultiCompanyGate = useGateValue(MULTI_COMPANY_ACCESS);

  return companyCount > 1 && hasMultiCompanyGate;
};

export default useHasMultiCompanyAccess;
